import { stepWizardCreate, stepWizardDefaultOptions } from '@subaio/components'

import { Loader } from 'components/Loader'

export const StepWizard = stepWizardCreate({
	...stepWizardDefaultOptions,
	loader: {
		...stepWizardDefaultOptions.loader,
		Component: Loader,
	},
})
